

/// <reference path="IntegratorMapping.ts" />

// Generated class IntegratorMappingRule_ManagedObject

class IntegratorMappingRule_ManagedObject extends IntegratorMapping
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: rule
    set rule(value:string) {
        this.setValueForKey(value, 'rule');
    }
    get rule():string {
        return this.valueForKey('rule');
    }
    set rulePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'rule');
    }
    get rulePrimitiveValue():string {
        return this.primitiveValueForKey('rule');
    }

    // Property: value
    set value(value:string) {
        this.setValueForKey(value, 'value');
    }
    get value():string {
        return this.valueForKey('value');
    }
    set valuePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'value');
    }
    get valuePrimitiveValue():string {
        return this.primitiveValueForKey('value');
    }

    // Property: valueType
    set valueType(value:string) {
        this.setValueForKey(value, 'valueType');
    }
    get valueType():string {
        return this.valueForKey('valueType');
    }
    set valueTypePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'valueType');
    }
    get valueTypePrimitiveValue():string {
        return this.primitiveValueForKey('valueType');
    }
    // Relationship: mappingInfo
    set mappingInfo(value:IntegratorMappingInfo) {
        this.setValueForKey(value, 'mappingInfo');
    }
    get mappingInfo():IntegratorMappingInfo {
        return this.valueForKey('mappingInfo') as IntegratorMappingInfo;
    }
}
